import { SourceQuote } from '@/app/components/testing-plan/components/test-details/types';
import { useState } from 'react';

const initialSourcesToLoad = 2;

export default function useLoadMoreSources(isOpen: boolean, sources: SourceQuote[]) {
  const [visibleSources, setVisibleSources] = useState<number>(initialSourcesToLoad);

  if (!isOpen && visibleSources !== initialSourcesToLoad) {
    setVisibleSources(initialSourcesToLoad);
  }

  const showLoadMoreButton = (sources.length ?? 0) > visibleSources;

  const handleLoadMoreSources = () => {
    if (sources) {
      setVisibleSources(sources.length || 0);
    }
  };
  return { visibleSources, showLoadMoreButton, handleLoadMoreSources };
}
